// extracted by mini-css-extract-plugin
module.exports = {"simulation":"Simulation_simulation__2V4Rt","panel":"Simulation_panel__23HGz","btns":"Simulation_btns__34Gsf"};